export const FETCH_POSTS = "FETCH_POSTS";
export const FETCH_POST = "FETCH_POST";
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH";
export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const LIKE = "LIKE";

export const SET_CURRENT_ID = "SET_CURRENT_ID";

export const SHOW_MODAL = "SHOW_MODAL";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

export const SIGN_UP = "SIGN_UP";
export const SIGN_IN = "SIGN_IN";

export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
